import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import parse from 'html-react-parser';
import GLOBAL_CONFIG from '../../config/config';
import TitleContent from '../../components/Content/TitleContent/TitleContent';
import GiftContent from '../../components/Content/GiftContent/GiftContent';
import appGoogleTracking from '../../modules/googletracking';
import { mainLoaderToggle } from '../../modules/helpers';
import { withCookies } from 'react-cookie';
import ValidateForm from '../../modules/validate';
import CampaignServices from '../../Services/Campaign';

class Holding extends Component {
    constructor(props) {
        super(props)

        // to check if the device is a mobile or not 
        this.state = {
            isMobile: false,
            isEmailSent: false,
            loaderSubmit: false
        }

        // this.displayFormSection.bind(this);
        this.processForm.bind(this);

    }

    componentDidMount() {
        const { t } = this.props;
        //Remove main loader
        mainLoaderToggle('hide');

        //Virtual page
        appGoogleTracking.dataLayerPush({
            'customEvent': {
                'event': 'virtual-page',
                'virtualUri': GLOBAL_CONFIG.Route.holding,
                'pageTitle': t('Meta.title')
            }
        });


        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        const { cookies } = this.props;
        if (cookies.get("_isPress") == "true") {
            this.setState({ isEmailSent: true });
        }
    }

    componentWillUnmount() {
        mainLoaderToggle('show');
    }

    resize() {
        // set isMobile to true if the device is a mobile and false otherwise 
        this.setState({ isMobile: window.innerWidth <= 768 });
    }

    //old formulaire easter 
    displayFormSection() {
        return (
            <div className={this.state.isEmailSent ? 'form-holding sent-email' : 'form-holding'}>
                <form
                    id="frm_holding"
                    name="frm_holding"
                    method="post"
                    action="/"
                    ref={form => this._FORM = form}
                    onSubmit={this.onSubmitHandler.bind(this)} noValidate>
                    <h4>
                        <span>Du möchtest den Start der Verlosung</span>auf keinen Fall verpassen?
                    </h4>
                    <p>
                        Wir erinnern dich rechtzeitig per E-Mail!
                    </p>
                    <div id="email" className="input-container">
                        <div className="form-input__container">
                            <input className="form-input__input js-event-type-in js-event-ab"
                                type="text"
                                placeholder="Vorname"
                                data-require="true"
                                data-type="text"
                                data-error-target="#error-text"
                                data-required-message=""
                                data-pattern-message=""
                                data-event-fieldname="Text"
                                data-event="form-click"
                                data-category="Form Action"
                                data-action="Text"
                                data-label="Type In"
                                ref={input => this._NAME = input}
                            />
                        </div>
                        <div className="form-input__container">
                            <input className="form-input__input js-event-type-in js-event-ab"
                                type="email"
                                placeholder="E-Mail-Adresse eingeben"
                                data-require="true"
                                data-type="regex"
                                data-error-target="#error-email"
                                data-regex-pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,17}$"
                                data-required-message=""
                                data-pattern-message="Huch – da hat sich wohl ein Fehler in die E-Mail-Adresse eingeschlichen. Bitte überprüfe deine E-Mail-Anschrift."
                                data-event-fieldname="Email"
                                data-event="form-click"
                                data-category="Form Action"
                                data-action="Email"
                                data-label="Type In"
                                ref={input => this._EMAIL = input}
                            />
                            <span id="error-email" className="form-input__error active"></span>
                        </div>
                    </div>

                    {
                        !this.state.isEmailSent ?
                            (
                                <div>
                                    <div id="checkbox" className="input-container">
                                        <label className="custom-inputs" htmlFor="newsletter">
                                            <span className="text-content">
                                                Ich möchte den regelmäßigen Newsletter mit Informationen zu Milka Produkten, Rezepten und Aktionen per E-Mail von der Mondelez Deutschland Services GmbH & Co. KG oder von verbundenen Unternehmen der Mondelez International Unternehmensgruppe erhalten. In diesem Zusammenhang wird auch mein Kauf- und Klickverhalten auf dieser Milka-Website analysiert. Diese Einwilligung kann jederzeit mit zukünftiger Wirkung hier widerrufen werden. Bitte beachten Sie auch unsere Datenschutzerklärung für weitere Informationen.
                                            </span>
                                            <input ref={check => this._CHECKBOX = check}
                                                type="checkbox"
                                                id="newsletter"
                                                name="newsletter"
                                                className="js-event-type-in js-event-ab"
                                                data-require="true"
                                                data-type="checkbox"
                                                data-event-fieldname="Newsletter"
                                                data-event="form-click"
                                                data-category="Form Action"
                                                data-action="Newsletter"
                                                data-label="Type In" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                    <button type={"submit"} className={"btn__container btn--primary"}>
                                        ERINNERE MICH
                                    </button>
                                </div>
                            )
                            :
                            (
                                <p className="email-sent">
                                    Deine E-Mail-Adresse wurde erfolgreich gespeichert.<br />
                                    Wir erinnern dich, sobald die Milka Osteraktion beginnt.
                                </p>
                            )
                    }
                </form>
            </div>
        );
    }

    onSubmitHandler(event) {
        event.preventDefault();
        if (this.state.isEmailSent) {
            return null;
        }

        const validateForm = ValidateForm.validateForm('frm_holding');
        if (validateForm) {
            this.processForm();
        } else {
            /**
             * Scroll To first error
             */
            let firstError = this._FORM.querySelector(".notvalid");
            if (!!firstError) {
                const yOffset = - 110,
                    y = firstError.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({
                    top: y,
                    behavior: 'smooth'
                });
            }
        }
    }

    processForm() {
        const { cookies } = this.props;
        let _data = {
            emailAddress: this._EMAIL.value,
            firstname: this._NAME.value,
            privacyPolicy: true
        }
        console.log("🚀 ~ file: Holding.js:191 ~ Holding ~ processForm ~ _data", _data)

        this.setState({ loaderSubmit: true });

        CampaignServices.NewsletterSubscribe(_data)
            .then((response) => {
                let { Success } = response.data;
                console.log(response);
                this.setState({ loaderSubmit: false });
                if (Success) {
                    this.setState({ isEmailSent: true });
                    const expireDate = new Date();
                    expireDate.setMonth(expireDate.getMonth() + 3);
                    cookies.set("_isPress", "true", { path: "/", expires: expireDate });

                    appGoogleTracking.dataLayerPush({
                        dataEvent: "subscribe_to_newsletter",
                        dataCategory: "Homepage",
                        dataAction: "Click Subscribe to Newsletter",
                        dataLabel: "ENG_OTHER_HOME",
                    });
                } else {
                    console.log("KO");
                }
            })
            .catch(() => {
                this.setState({ loaderSubmit: false });
                console.log("catch : KO");
            });
    }


    render() {

        const { t } = this.props;
        let image = {
            desktop: t('Page.Holding.bottomBanner.desktop'),
            mobile: t('Page.Holding.bottomBanner.mobile')
        };
        // const image = {
        //     desktop: t('Page.Holding.giftContentImage.desktop'),
        //     mobile: t('Page.Holding.giftContentImage.mobile'),
        // }

        return (
            <div className="content-holding">
                <TitleContent
                    heading={t('Page.Holding.title')}
                    paragraph={parse(t('Page.Holding.paragraph'))}
                />

                {
                    this.state.loaderSubmit ?
                        <div className="simple-loader__container active">
                            <div className="simple-loader__indicator"></div>
                        </div>
                        : null
                }

                <TitleContent 
                    heading={t('Page.Holding.title2')}/>

                <div className='teaser-holding'>
                    <picture>
                        <source media="(min-width:768px)" srcSet={t('Page.Holding.imageTeaser.desktop')}/>
                        <img src={t('Page.Holding.imageTeaser.mobile')} alt={t('Page.Holding.imageTeaser.alt')}/>
                    </picture>
                    <div className='teaser-buttons'>
                        <a className='external-shops' data-event="buy_milka_products" data-category="Announcement Page" data-action="Click on Products Links" data-label="Gurkel" onClick={appGoogleTracking.processEventCTA} target="_blank" href='https://www.gurkerl.at/suche/marke/milka?q=Milka&companyId=1'><img src='/resources/images/gluecksrad/gurkel.png'></img></a>
                        <a className='external-shops' data-event="buy_milka_products" data-category="Announcement Page" data-action="Click on Products Links" data-label="Alfies" onClick={appGoogleTracking.processEventCTA} target="_blank" href='https://www.alfies.at/shop?utm_source=gewinnspiele&utm_medium= referral&utm_campaign=milka'><img src='/resources/images/gluecksrad/alfies.png'></img></a>
                        <a className='external-shops' data-event="buy_milka_products" data-category="Announcement Page" data-action="Click on Products Links" data-label="Foodora" onClick={appGoogleTracking.processEventCTA} target="_blank" href='https://foodora.at'><img src='/resources/images/gluecksrad/foodora.png'></img></a>
                    </div>
                </div>
            </div>
        );
    }
}

export default withCookies(withTranslation()(Holding));